import React from "react";
import Text from "../Text";

interface P {
  value: React.ReactNode;
}

const Description = ({ value }: P) => <Text type="body2">{value}</Text>;

export default React.memo(Description);
